import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import '../../css/common-components.css';

import ErrorIcon from '../../images/error-icon.svg';
import ThirdPartyCookiesHelp from '../ThirdPartyCookiesHelp.jsx';

import styles from './Error.module.css';

const Error = ({ 
  title = "", 
  message = "", 
  buttonText = "Close",
  onButtonClick = () => {
    window.parent.postMessage(JSON.stringify({ action: "DONE" }), "*");
  }
}) => {
  const [searchParams] = useSearchParams();
  const isPopup = searchParams.has('popup');
  const tpcBlocked = searchParams.get('tpc') === 'blocked';
  // Set up message listener for any iframe messages
  useEffect(() => {
    const handleMessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.action === "DONE") {
          // Forward to parent if needed
          window.parent.postMessage(JSON.stringify({ action: "DONE" }), "*");
        }
      } catch (e) {
        // Not JSON, ignore
      }
    };
    
    window.addEventListener("message", handleMessage);
    
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorCard}>
        <div className={styles.errorIcon}>
           <img src={ErrorIcon} alt="Error" />
        </div>
        <h1 className={styles.errorTitle}>{title}</h1>
        { tpcBlocked ? (
          <ThirdPartyCookiesHelp />
        ) : (
          <p className={styles.errorMessage}>{message}</p>
        )}
        {isPopup && (
          <button className="btn-outline-primary" onClick={onButtonClick}>
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default Error;